import { connect } from 'react-redux';
import { IState } from '../../store';
import {
  openCommercialWidgetModal,
  closeAndSaveCommercialSurvey,
  sendCommercialSurvey,
} from '../../store/popups/commecial_survey';

import { AnalyticsBlock } from './AnalyticsBlock';
import { IAnalyticsBlockDispatchProps, IAnalyticsBlockStoreProps } from './typings';
import { makeClickHandler, makeSurveyAnalyticsHandler } from '../../utils/tracking';

export const mapStateToProps = (state: IState): IAnalyticsBlockStoreProps => {
  const {
    abGroup,
    offerData: { offer, user, agent },
  } = state;

  return {
    isOpen: state.commercialSurvey.isOpen,
    onOpenClick: makeClickHandler({
      offer,
      user,
      abGroup,
      agent,
    }),
    onTrackOfferPullActions: makeSurveyAnalyticsHandler({
      offer,
      user,
      abGroup,
      agent,
    }),
  };
};

export const mapDispatchToProps: IAnalyticsBlockDispatchProps = {
  onButtonClick: openCommercialWidgetModal,
  onWidgetClose: closeAndSaveCommercialSurvey,
  onWidgetSubmit: sendCommercialSurvey,
};

export const AnalyticsBlockContainer = connect(mapStateToProps, mapDispatchToProps)(AnalyticsBlock);
